// import displayHelper from "@/util/display_helper"
// import datetimeHelper from "@/util/datetime_helper"

export default function (copy) {
  let object;
  if (copy) {
    object = JSON.parse(JSON.stringify(copy));
  } else {
    object = {
      itemId: 872914,
      accountCode: '16722827',
      macAddress: '743AEFB9769D',
      serialNumber: 'BS1007189A000805',
      ownership: 'Purchased',
      model: 'AR2140 Router',
      modelId: 1599,
      modelDescription: 'Kaon AR2140 Router',
      type: 'Router',
      make: 'Kaon',
      wifiFeature: {
        numberOf24GhzNetworks: 1,
        numberOf5GhzNetworks: 1
      },
      purchaseDate: '2021-03-18T09:50:34.953',
      status: 'Allocated'
    };
  }
  object.getItemId = function getItemId() {
    return object.itemId ? object.itemId : '';
  }
  object.getMacAddress = function getMacAddress() {
    return object.macAddress ? object.macAddress : '';
  }
  object.getSerialNumber = function getSerialNumber() {
    return object.serialNumber ? object.serialNumber : '';
  }
  object.getModel = function getModel() {
    return object.model ? object.model : '';
  }
  object.formattedData = function formattedData() {
    return [
      {
        text: 'Vocus ID:', value: this.getItemId()
      },
      {
        text: 'MAC Address:', value: this.getMacAddress()
      },
      {
        text: 'Serial Number:', value: this.getSerialNumber()
      },
      {
        text: 'Model:', value: this.getModel()
      },
    ];
  };
  return object;
}

